<template>
  <v-container>
    <v-img
      :src="culColour"
      class="logo"
      position="left top"
    />
    <HelpPage />
    <v-btn
      v-if="$routerHistory.hasPrevious()"
      :to="{ path: $routerHistory.previous().path }"
    >
      GO BACK
    </v-btn>
  </v-container>
</template>

<script>
  import culColour from '@/assets/cul_colour.png';
  import HelpPage from "@/components/HelpPage.vue";

  export default {
    components: {
      HelpPage
    },
    data: () => ({
      culColour
    }),
  }
</script>
